import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "project__media"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "project__info" }
const _hoisted_4 = { class: "project__meta" }
const _hoisted_5 = { class: "project__chip project__chip--year" }
const _hoisted_6 = { class: "project__chip project__chip--status" }
const _hoisted_7 = { class: "project__title" }
const _hoisted_8 = { class: "project__subtitle" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(['project', 'glass-card', { 'project--no-image': !_ctx.image }])
  }, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.image,
            alt: _ctx.title,
            class: "project__img"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.year), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.inProgress ? _ctx.$t("Project.inProgress") : _ctx.$t("Project.finished")), 1)
      ]),
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.subtitle), 1),
      (_ctx.link && _ctx.action)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.link,
            class: "project__action"
          }, _toDisplayString(_ctx.action), 9, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 2))
}